import React from 'react'
import { connect } from 'react-redux'
import { LocalForm, Control, actions } from 'react-redux-form'
import Errors from './Errors'

import {
  update_account
 } from '../actions'

const { toast, updateTextFields } = window.M

const mapStateToProps = state => {
  return {
    errors: state.account.errors
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateAccount: (account_id, values) => dispatch( update_account(account_id, values) )
  }
}

class ConnectedAccountRowEdit extends React.Component {

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  cancel() {
    this.formDispatch(actions.reset('localAccount'));
    this.props.cancel()

    setTimeout(function(){
      updateTextFields()
    }, 150)
  }

  componentDidUpdate(prevProps, prevState) {
    const {account} = this.props
    const previousAccount = prevProps.account

    if (JSON.stringify(previousAccount) !== JSON.stringify(account)) {
      toast({
        html: "Account data updated",
        displayLength: 1000,
        inDuration: 0
      })
      return this.cancel()
    }
  }

  componentDidMount() {
    setTimeout(function(){
      updateTextFields()
    }, 150)
  }

  handleSubmit(values) {
    const { account } = this.props
    const { id } = account
    this.props.updateAccount(id, values)
  }

  render() {
    const {showForm, account, errors} = this.props;

    if (showForm === "hide") {
      return ''
    }
    
    const rowClass = "inlineForm " + showForm.replace('hide','hidden')

    const {id, name, description } = account

    const showErrors = (showForm === "") ? errors : []

    return (
        <tr className={rowClass}>

          <td colSpan={5}>
            <div>
              <LocalForm
              model="localAccount"
              getDispatch={(dispatch) => this.attachDispatch(dispatch)}
              onSubmit = { (values) => {
                this.handleSubmit(values)
              }}
              initialState={{
                name: name,
                description: description || ''
              }}
              >
                <div className="row inlineRow">
                  <div className="col xl10 l10 s12 row">
                    <div className="input-field col s12 l5 xl5" style={{"paddingTop":"9px"}}>
                      <label htmlFor={`name_${id}`} >Account name</label>
                      <Control.text id={`name_${id}`} model=".name" />
                    </div>

                    <div className="input-field col s12 l7 xl7">
                      <label htmlFor={`description_${id}`} >Account description</label>
                      <Control.textarea id={`description_${id}`} model=".description" className="materialize-textarea"/>
                    </div>


                  </div>
                  <div className="col xl2 l2 s12 formButtons">
                    <button className="btn-small btn-flat" title="Save"><i className="material-icons tiny c-light-green">save</i></button>
                    <a href='' className="btn-small btn-flat hover-red" title="Cancel" onClick={ e=> {
                      e.preventDefault()
                      this.cancel()
                    }}><i className="material-icons tiny c-red darken-1">cancel</i></a>
                  </div>
                </div>

              </LocalForm>

            </div>
            <Errors errors={showErrors}/>
          </td>

        </tr>

    )
  }

}

const AccountRowEdit = connect(mapStateToProps, mapDispatchToProps)(ConnectedAccountRowEdit)

export default AccountRowEdit



// WEBPACK FOOTER //
// ./src/js/components/AccountRowEdit.js